<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 24 24" :width="width" :height="height" class="" style="enable-background:new 0 0 24 24;" xml:space="preserve">
        <rect class="st0" />
        <path :class="secondaryColor" d="M14.43,12.34c1.79-1.01,2.91-3.05,2.47-5.34C16.53,5.08,15,3.52,13.08,3.11C9.85,2.43,7,4.88,7,8
	c0,1.87,1.04,3.49,2.57,4.34c-3.44,0.96-6.04,3.91-6.5,7.53C3,20.47,3.47,21,4.07,21h15.86c0.6,0,1.07-0.53,1-1.13
	C20.48,16.25,17.87,13.31,14.43,12.34z"/>
</svg>

</template>

<script>
export default {
    name: "myAccountIcon",
    props: ['width', 'height'],
    computed: {
        secondaryColor() {
            return 'svg-secondary-color';
        }
    }
}
</script>

<style scoped>
.st0{opacity:0;fill:#FFFFFF;}

</style>



// WEBPACK FOOTER //
// src/common/components/svg/shared/myAccountIcon.vue